import { Box, styled } from '@mui/material';

export const WarningBox = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  padding: '12px',
  gap: '6px',
  borderRadius: '0 10px 0 10px',
  border: '1px solid rgba(229, 128, 122, 0.35)',
  backgroundColor: '#FFE8E8'
});
